import { deleteVideoReaction, getVideoReactions } from 'lib/api';
import { CreateParams, GlobalAction, VIDEO_REACTIONS_ACTIONS } from '.';

const {
  GET_VIDEO_REACTIONS_START,
  GET_VIDEO_REACTIONS_ERROR,
  GET_VIDEO_REACTIONS_SUCCESS,
  DELETE_VIDEO_REACTION_START,
  DELETE_VIDEO_REACTION_ERROR,
  DELETE_VIDEO_REACTION_SUCCESS,
} = VIDEO_REACTIONS_ACTIONS;

export const loadVideoReactions = async ({
  videoId,
  dispatch,
}: {
  videoId: string;
  dispatch: React.Dispatch<GlobalAction>;
}): Promise<void> => {
  dispatch({ type: GET_VIDEO_REACTIONS_START });

  const response = await getVideoReactions({ videoId }).catch(err => err);
  if (response instanceof Error) {
    dispatch({
      type: GET_VIDEO_REACTIONS_ERROR,
      error: response.message,
    });
    return;
  }
  dispatch({
    type: GET_VIDEO_REACTIONS_SUCCESS,
    payload: {
      videoReactions: response,
    },
  });
};

export const removeVideoReaction = async ({
  data,
  dispatch,
}: CreateParams): Promise<void> => {
  dispatch({ type: DELETE_VIDEO_REACTION_START });

  const response = await deleteVideoReaction(
    data.videoId,
    data.reactionId
  ).catch(err => err);
  if (response instanceof Error) {
    dispatch({
      type: DELETE_VIDEO_REACTION_ERROR,
      error: response.message,
    });
    return;
  }
  const payload = {
    reactionId: data.reactionId,
  };
  dispatch({ type: DELETE_VIDEO_REACTION_SUCCESS, payload });
};
